import { useState } from "react";
import { useTranslation } from "react-i18next";

import { Form, Formik } from "formik";
import { Grid } from "@mui/material";

import Field from "../../component/Field";
import Label from "../../component/Label";
import Toaster from "../../component/Toaster";
import SelectField from "../../component/SelectField";
import { CommonUtil, FormValidation, LoginUserDetails } from "../../util/Utils";

import { useAppDispatch } from "../../store/hooks";
import GlobalLoader from "../../component/GlobalLoader";
import { CheckCircle, Cancel } from "@mui/icons-material/";
import * as Yup from "yup";
import { GENDER } from "../../util/LookupConst";
import "./addCi.scss";
import { courseInstructorAction } from "../../store/courseInstructor/courseInstructorSlice";

interface AddCiProps {
  ciCreated?: any;
}
const AddCi = (props: AddCiProps) => {
  const { ciCreated } = props;
  const dispatch = useAppDispatch();
  const [spinner, setSpinner] = useState<boolean>(false);
  const { t } = useTranslation();
  const [initialValue, setInitialValue] = useState<any>({
    franchiseeId: LoginUserDetails.getUserDetails()?.franchiseeId,
    id: "",
    courseInstructorName: "",
    mobileNumber: "",
    courseInstructorId: "",
    gender: GENDER[1].value,
    active: "Yes",
  });
  const handleSubmit = () => {};

  const AddCi = (values: any, dirty: any) => {
    if (dirty) {
      setSpinner(true);
      dispatch(
        courseInstructorAction({
          formValues: values,
          apiAction: "create",
        })
      )
        .then((result: any) => {
          if (result?.payload?.status === 200) {
            ciCreated(result?.payload);
            Toaster.success(undefined, result.payload.data.message);
          } else {
            Toaster.error(undefined, result.payload);
          }
        })
        .catch((err: any) => {
          console.log(err); //This console for debug the app if any error occurred in DEV
        })
        .finally(() => {
          setSpinner(false);
        });
    }
  };
  return (
    <div className="sidenav-container">
      <div className="single">
        <Formik
          initialValues={initialValue}
          enableReinitialize={true}
          onSubmit={handleSubmit}
          validationSchema={Yup.object().shape({
            courseInstructorName: Yup.string()
              .required(`${t("instructorName")} ${t("is")} ${t("required")}`)
              .matches(
                FormValidation.alphaNumericWithSpacePattern(),
                `${t("userRole.roleName")} ${t("is")} ${t("incorrect")}`
              ),
            mobileNumber: Yup.string()
              .required(
                `${t("forgetPassword.mobileNumber")} ${t("is")} ${t(
                  "required"
                )}`
              )
              .min(10, `${t("mobileNumber")} ${t("is")} ${t("incorrect")}`),
          })}
        >
          {({
            values,
            handleChange,
            handleBlur,
            setFieldValue,
            errors,
            touched,
            dirty,
            isValid,
            handleSubmit,
            handleReset,
            resetForm,
          }: any) => {
            return (
              <Form onSubmit={handleSubmit} onReset={handleReset}>
                <Grid
                  container
                  className="flex"
                  style={{ flexDirection: "column" }}
                >
                  <div
                    style={{ marginBottom: "20px" }}
                    className="add-ci form-ele-gap inherit-number-field"
                  >
                    <Label required title={t("instructorName")} />
                    <Field
                      name={"courseInstructorName"}
                      fullWidth
                      variant="outlined"
                      margin="dense"
                      value={values.courseInstructorName}
                      onInput={() => FormValidation.getNamePattern()}
                      placeholder={t("Enter Here")}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={
                        errors.courseInstructorName &&
                        touched.courseInstructorName
                      }
                    />
                    <Label required title={t("mobileNo")} />
                    <Field
                      name={`mobileNumber`}
                      fullWidth
                      type="number"
                      variant="outlined"
                      margin="dense"
                      placeholder={t("enterHere")}
                      onInput={
                        LoginUserDetails.getCountry() === "India"
                          ? (e: any) => CommonUtil.checkLengthHandler(e, 10)
                          : ""
                      }
                      value={values.mobileNumber}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={errors.mobileNumber && touched.mobileNumber}
                    />
                    <div className="flex">
                      <div style={{ width: "70%" }}>
                        <Label required title={t("gender")} />
                        <SelectField
                          name="gender"
                          value={values.gender}
                          label={t("gender")}
                          style={{ width: "70%" }}
                          onChange={handleChange}
                          options={GENDER}
                        />
                      </div>
                      <div className="flex center-end action-button-add-ci">
                        <div
                          className="add-course-instructor-icon pointer"
                          onClick={() => {
                            resetForm();
                          }}
                        >
                          <Cancel className="reject-button" />
                        </div>
                        <div className="add-course-instructor-icon pointer">
                          <CheckCircle
                            className={
                              dirty ? "accept-button" : "accept-button-disabled"
                            }
                            onClick={() => {
                              AddCi(values, dirty);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </Grid>
              </Form>
            );
          }}
        </Formik>
        <GlobalLoader loading={spinner} />
      </div>
    </div>
  );
};
export default AddCi;
